import React from 'react';

import { useTranslation } from 'react-i18next';
import { Card, HStack, Heading, Image, Text, VStack, useToken } from '@gluestack-ui/themed';
import { getColorForModule } from '../../../common/utils/getColorForModule';

const CurrentModuleCard = React.memo(({ module, course, ...props }) => {
  const { t } = useTranslation();
  const imageSource = React.useMemo(() => {
    if (!module) return require('../../../assets/img/fallback-module-image.jpg');
    return module?.imageUrl ? { uri: module.imageUrl } : require('../../../assets/img/fallback-module-image.jpg');
  }, [module?.imageUrl]);

  if (!module) return null;

  return (
    <Card w="100%" h={100} p={0} overflow="hidden" testID="current-module-card" {...props}>
      <HStack
        w="100%"
        h="100%"
        p={0}
        pr="$4"
        m={0}
        bg={useToken('colors', `${getColorForModule(module)}400`)}
        alignItems="left"
        $lg-justifyContent="space-between"
        $base-justifyContent="flex-start"
        $base-flexDirection="column"
        $lg-flexDirection="row"
      >
        <HStack flex={1}>
          <Image
            source={imageSource}
            alt="Module Image"
            testID="current-module-image"
            resizeMode="cover"
            $base-w={0}
            $md-w={250}
            $lg-w={300}
            h={100}
          />
          <VStack pl="$8" pr="$2" justifyContent="center" flex={1}>
            <Heading numberOfLines={2} lineHeight="$lg">
              {module.title}
            </Heading>
            <Text $md-display="flex" $base-display="none" size="sm" color="$textHeading" numberOfLines={1}>
              {!!course
                ? course?.title.length > 50
                  ? course.title.substring(0, 50) + '...'
                  : course.title
                : 'No Course'}
              {!!module.metadata?.ects &&
                module.metadata.ects > 0 &&
                t('student.module.current-module.current-module-ects', { ects: module.metadata.ects })}
            </Text>
          </VStack>
        </HStack>
      </HStack>
    </Card>
  );
});

export default CurrentModuleCard;
